// «Только что вошёл»: отметка вкладки после входа по логину и паролю. Колокольчик показывает окна
// уведомлений «при входе» только при ней и сразу её снимает, так что перезагрузка страницы, новая
// вкладка или переход по разделам окон не вызывают (29.10.2026).
const KEY = 'sl_just_signed_in'

export function markSignedIn() {
  try {
    sessionStorage.setItem(KEY, '1')
  } catch (e) {
    // storage is off: the windows are not shown, the bell still has the red dot
  }
}

// true once after a sign-in in this tab
export function takeSignedIn() {
  try {
    const was = sessionStorage.getItem(KEY) === '1'
    sessionStorage.removeItem(KEY)
    return was
  } catch (e) {
    return false
  }
}
